const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,

  
  WORKER: {
    LOGIN: "/worker/login",
    REGISTER: "/worker/register",
    STATUS: "/worker/status",
    PROFILE: "/worker/profile",
    PROFILE_PHOTO: "/worker/profile-photo"
  }

 
};

export default config;
